import { CompareHelper, ConvertHelper } from '@barthauer/abc/core';

export interface SettingsCatalogueKey {
  [settingsKeyName: string]: string;
}
export interface SettingsCatalogueValue {
  [settingName: string]: unknown;
}
export interface SettingsCatalogueEntry {
  Key: SettingsCatalogueKey;
  Value: SettingsCatalogueValue;
}

export function areKeysEqual(catalogueKey1: SettingsCatalogueKey, catalogueKey2: SettingsCatalogueKey): boolean {
  return CompareHelper.areDeepEqual(catalogueKey1, catalogueKey2);
}

export interface ISettingInfo {
  readonly settingName: string;
  readonly responsePropertyName?: string;
  readonly settingValueType?:
    | StringConstructor
    | NumberConstructor
    | BooleanConstructor
    | DateConstructor
    | ObjectConstructor
    | ArrayConstructor;
  readonly isOptional?: boolean;
}

export class SettingInfo implements ISettingInfo {
  constructor(info: ISettingInfo) {
    this.settingName = info.settingName;
    this.responsePropertyName = info.responsePropertyName ?? info.settingName;
    this.settingValueType = info.settingValueType ?? String;
    this.isOptional = info.isOptional ?? false;
  }

  public readonly responsePropertyName: string;
  public readonly settingName: string;

  public readonly settingValueType:
    | StringConstructor
    | NumberConstructor
    | BooleanConstructor
    | DateConstructor
    | ObjectConstructor
    | ArrayConstructor;
  public readonly isOptional: boolean;

  public getTextFromSettingValue(value: any): string {
    return ConvertHelper.toString(value);
  }

  public getSettingValueFromText(text: string): string | number | boolean | Date | object {
    return ConvertHelper.fromString(this.settingValueType, text);
  }
}

export interface IWritableSettings<TSettings> {
  load(settings: TSettings): void;
}
